/**
 * fruit-info.js
 * Handles bear animation, height equalisation, and the fruit-detail modal
 * for the fruit-info section.
 *
 * Loaded as a deferred script from fruit-info.liquid via:
 *   <script src="{{ 'fruit-info.js' | asset_url }}" defer></script>
 *
 * The section element carries a `data-section-id` attribute that is used
 * to locate the correct DOM root and JSON data block — no Liquid needed here.
 */

(function () {
    'use strict';

    function initFruitInfo(sectionEl) {
        var sectionId = sectionEl.dataset.sectionId;
        var activeFruitId = null;
        var modal = sectionEl.querySelector('.fruits-modal');

        var bearImage = sectionEl.querySelector('.bear-image');

        // Intersection Observer — bear entrance animation
        if (bearImage) {
            var observer = new IntersectionObserver(
                function (entries) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting) {
                            bearImage.classList.add('animated');
                        } else {
                            bearImage.classList.remove('animated');
                        }
                    });
                },
                { threshold: 0.35 }
            );
            observer.observe(sectionEl);
        }

        // Height equalisation
        function equalizeBottomFruitInfoHeight() {
            var cards = sectionEl.querySelectorAll('.bottom-fruit-info');
            if (!cards.length) return;

            cards.forEach(function (card) { card.style.minHeight = ''; });

            if (window.innerWidth < 992) return;

            var maxHeight = 590;
            cards.forEach(function (card) {
                maxHeight = Math.max(maxHeight, card.offsetHeight);
            });
            cards.forEach(function (card) {
                card.style.minHeight = maxHeight + 'px';
            });
        }

        function setFruitImagesBlockHeight() {
            var block = sectionEl.querySelector('.fruit-images-block');
            var fruitSlideCard = sectionEl.querySelector('.fruit-slide__card');
            if (!block) return;

            if (window.innerWidth > 640) {
                block.style.minHeight = '';
                if (fruitSlideCard) {
                    fruitSlideCard.style.minHeight = '';
                    fruitSlideCard.style.height = '';
                }
                return;
            }

            var fruits = block.querySelectorAll('.fruit-images');
            if (!fruits.length) return;

            block.style.minHeight = '';
            var maxBottom = 0;
            fruits.forEach(function (fruit) {
                maxBottom = Math.max(maxBottom, fruit.offsetTop + fruit.offsetHeight);
            });
            block.style.minHeight = (maxBottom + 20) + 'px';

            if (fruitSlideCard) {
                fruitSlideCard.style.minHeight = '';
                fruitSlideCard.style.height = '';
            }
        }

        window.addEventListener('load', function () {
            equalizeBottomFruitInfoHeight();
            setFruitImagesBlockHeight();
        });

        window.addEventListener('resize', function () {
            equalizeBottomFruitInfoHeight();
            setFruitImagesBlockHeight();

            if (activeFruitId && modal && modal.classList.contains('is-open')) {
                document.body.style.overflow = 'hidden';
                document.documentElement.style.overflow = 'hidden';
            }
        });

        // Fruit-detail modal
        var closeBtn = sectionEl.querySelector('.modal-close-icon');
        var fruitItems = sectionEl.querySelectorAll('.fruit-images .icon-btn');

        // Parse block data serialised as JSON in the section
        var fruitData = {};
        var dataElement = document.getElementById('fruit-data-' + sectionId);
        if (dataElement) {
            try {
                fruitData = JSON.parse(dataElement.textContent);
            } catch (e) {
                console.error('[fruit-info] Error parsing fruit data JSON:', e);
            }
        }

        var currentVarietyIndex = 0;
        var activeFruitData = null;

        var prevBtn = modal.querySelector('.prev-variety');
        var nextBtn = modal.querySelector('.next-variety');

        function renderVariety(index, isInitial) {
            if (!activeFruitData || !activeFruitData.varieties || activeFruitData.varieties.length === 0) return;
            
            var variety = activeFruitData.varieties[index];
            var infoEl = modal.querySelector('.fruit-slide__info');
            var metaEl = modal.querySelector('.fruit-meta');

            function updateText() {
                if (infoEl) infoEl.innerHTML = variety.content;

                var metaItems = modal.querySelectorAll('.fruit-meta__item');
                if (metaItems.length >= 1) {
                    var varietalVal = metaItems[0].querySelector('.fruit-meta__varietal--name strong');
                    if (varietalVal) varietalVal.textContent = variety.varietal;
                    if (variety.varietal) {
                        metaItems[0].style.display = '';
                    } else {
                        metaItems[0].style.display = 'none';
                    }
                }

                var tastingItem = modal.querySelector('.fruit-meta__item--full');
                var tastingVal = tastingItem ? tastingItem.querySelector('.fruit-meta__varietal--name strong') : null;
                if (tastingVal) tastingVal.textContent = variety.tasting_note;
                if (tastingItem) {
                    if (variety.tasting_note) {
                        tastingItem.style.display = '';
                    } else {
                        tastingItem.style.display = 'none';
                    }
                }

                modal.querySelectorAll('.fun-info').forEach(function (el) {
                    el.innerHTML = variety.fun_fact; // Rich text
                    var parentCol = el.closest('.meta-col');
                    if (parentCol) {
                        if (variety.fun_fact) {
                            parentCol.style.display = '';
                        } else {
                            parentCol.style.display = 'none';
                        }
                    }
                });

                if (infoEl) infoEl.style.opacity = '1';
                if (metaEl) metaEl.style.opacity = '1';
            }

            if (isInitial) {
                if (infoEl) {
                    infoEl.style.transition = 'none';
                    infoEl.style.opacity = '1';
                }
                if (metaEl) {
                    metaEl.style.transition = 'none';
                    metaEl.style.opacity = '1';
                }
                updateText();
                // Enable transitions after initial setup
                setTimeout(function() {
                    if (infoEl) infoEl.style.transition = 'opacity 0.25s ease-in-out';
                    if (metaEl) metaEl.style.transition = 'opacity 0.25s ease-in-out';
                }, 50);
            } else {
                if (infoEl) infoEl.style.opacity = '0';
                if (metaEl) metaEl.style.opacity = '0';
                setTimeout(updateText, 250);
            }

            if (activeFruitData.varieties.length > 1) {
                if (prevBtn) prevBtn.style.display = '';
                if (nextBtn) nextBtn.style.display = '';
            } else {
                if (prevBtn) prevBtn.style.display = 'none';
                if (nextBtn) nextBtn.style.display = 'none';
            }
        }

        if (prevBtn) {
            prevBtn.addEventListener('click', function(e) {
                e.stopPropagation();
                if (currentVarietyIndex > 0) {
                    currentVarietyIndex--;
                    renderVariety(currentVarietyIndex, false);
                } else if (activeFruitData && activeFruitData.varieties) {
                    currentVarietyIndex = activeFruitData.varieties.length - 1;
                    renderVariety(currentVarietyIndex, false);
                }
            });
        }

        if (nextBtn) {
            nextBtn.addEventListener('click', function(e) {
                e.stopPropagation();
                if (activeFruitData && currentVarietyIndex < activeFruitData.varieties.length - 1) {
                    currentVarietyIndex++;
                    renderVariety(currentVarietyIndex, false);
                } else {
                    currentVarietyIndex = 0;
                    renderVariety(currentVarietyIndex, false);
                }
            });
        }

        function openModal(fruitId) {
            activeFruitData = fruitData[fruitId];
            if (!activeFruitData || !modal) return;

            // Block a second modal while one is already active
            if (activeFruitId && activeFruitId !== fruitId) {
                sectionEl.querySelectorAll('.fruit-images .icon-btn .arrow-icon').forEach(function (icon) {
                    icon.setAttribute('title', 'Another fruit modal is already open. Please close it first.');
                });
                return;
            }

            activeFruitId = fruitId;
            currentVarietyIndex = 0;

            var titleEl = modal.querySelector('.fruit-slide__heading--title');
            if (titleEl) titleEl.textContent = activeFruitData.title;

            renderVariety(currentVarietyIndex, true);

            var topImgContainer = modal.querySelector('.fruit-slide__top-image');
            if (topImgContainer) {
                if (activeFruitData.top_image) {
                    var topImg = topImgContainer.querySelector('img');
                    if (!topImg) {
                        topImg = document.createElement('img');
                        topImg.loading = 'lazy';
                        topImgContainer.appendChild(topImg);
                    }
                    topImg.src = activeFruitData.top_image;
                    topImg.alt = activeFruitData.title;
                    topImgContainer.style.display = 'block';
                } else {
                    topImgContainer.style.display = 'none';
                }
            }

            var bottomImgContainer = modal.querySelector('.fruit-slide__bottom-image');
            if (bottomImgContainer) {
                if (activeFruitData.bottom_image) {
                    var bottomImg = bottomImgContainer.querySelector('img');
                    if (!bottomImg) {
                        bottomImg = document.createElement('img');
                        bottomImg.loading = 'lazy';
                        bottomImgContainer.appendChild(bottomImg);
                    }
                    bottomImg.src = activeFruitData.bottom_image;
                    bottomImg.alt = activeFruitData.title;
                    bottomImgContainer.style.display = 'block';
                } else {
                    bottomImgContainer.style.display = 'none';
                }
            }

            if (typeof modal.showModal === 'function' && !modal.open) modal.showModal();
            modal.classList.add('is-open');
            document.documentElement.classList.add('fruit-modal-open');

            var header = document.querySelector('.header-section-block');
            if (header) header.style.top = '-' + header.offsetHeight + 'px';

            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';

            document.querySelectorAll('.fruit-images[data-fruit] .icon-btn').forEach(function (icon) {
                icon.classList.remove('hidden');
            });
            var activeIcon = document.querySelector('.fruit-images[data-fruit="' + fruitId + '"] .icon-btn');
            if (activeIcon) activeIcon.classList.add('hidden');
        }

        function closeModal() {
            if (modal) {
                if (typeof modal.close === 'function' && modal.open) modal.close();
                modal.classList.remove('is-open');
            }

            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
            document.documentElement.classList.remove('fruit-modal-open');

            activeFruitId = null;
            activeFruitData = null;

            document.querySelectorAll('.fruit-images[data-fruit] .icon-btn').forEach(function (icon) {
                icon.classList.remove('hidden');
            });
        }

        fruitItems.forEach(function (item) {
            item.addEventListener('click', function (e) {
                e.stopPropagation();
                var fruitImages = this.closest('.fruit-images');
                var fruitId = fruitImages.getAttribute('data-fruit') || fruitImages.getAttribute('data-fruits');
                openModal(fruitId);
            });
        });

        if (closeBtn) {
            closeBtn.addEventListener('click', function (e) {
                e.stopPropagation();
                closeModal();
            });
        }

        sectionEl.addEventListener('click', function (e) {
            if (!activeFruitId || !modal) return;
            if (modal.contains(e.target)) return;
            if (e.target.closest('.fruit-images .icon-btn')) return;
            closeModal();
        });

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' || e.keyCode === 27) closeModal();
        });
    }

    // Initialise every fruit-info section on the page
    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('.fruit-info-block[data-section-id]').forEach(initFruitInfo);
    });
})();
